import GeoJSON from "ol/format/GeoJSON";
import {fromLonLat} from 'ol/proj';
import { Vector as VectorLayer } from 'ol/layer';
import {Vector as VectorSource} from "ol/source";
import {Fill, Stroke, Style} from "ol/style";
import {Vector} from "ol/layer";
import { isEmpty as isEmptyExtent } from "ol/extent";

import MainStore from "../store/MainStore";
class MapGeoJsonService {

    constructor() {
    }

    addGeoJsonLayer(refMap, geoJsonData, typeTerr=null, getExtend=true) {

        this.refMap = refMap;
        let mapLayers = refMap.getLayers().getArray();
        let vectorSource = null
        let clearVectorLayer = MainStore.getState().LayersReducer.clearVectorLayer;
        if(typeTerr && typeTerr === 'parcelle'){
            mapLayers.filter(layer => layer.get('name') === 'geomlayer').forEach(layer =>vectorSource = layer.getSource());
            if(vectorSource && !clearVectorLayer) {
                vectorSource.addFeatures(new GeoJSON().readFeatures(geoJsonData));
            }else{
                vectorSource = new VectorSource({
                    features: (new GeoJSON()).readFeatures(geoJsonData)
                });
                //ps.cleanVectorLayer(false)
                MainStore.dispatch({type: 'CLEAR_VECTOR_LAYER', data: false})
            }
        }else{
            vectorSource = new VectorSource({features: (new GeoJSON()).readFeatures(geoJsonData)});
        }
        mapLayers.filter(layer => layer.get('name') === 'geomlayer')
            .forEach(layer => refMap.removeLayer(layer));
        let vectorStyle = new Style({
            stroke: new Stroke({
                color: '#58D2C3',
                lineDash:[10,10],
                lineCap: 'square',
                width: 5,

            }),
            fill: new Fill({
                color: 'rgba(88,215,195,0.1)'
            })
        })
        let vectorLayer = new Vector({
            source: vectorSource,
            style: vectorStyle
        });
        vectorLayer.set('name', 'geomlayer')
        vectorLayer.set('title', 'Unité foncière')
        vectorLayer.set('displayInLayerSwitcher', false)
        vectorLayer.setZIndex(999);
        refMap.addLayer(vectorLayer);
        (getExtend)?refMap.getView().fit(vectorSource.getExtent(),{maxZoom: 19}, refMap.getSize()):null;

    }

    /**
     * Removes a feature by ID from the vector layer.
     * @param {Map} map - The OpenLayers map instance.
     * @param {string} featureId - The ID of the feature to remove.
     */
    removeFeature(map, featureId) {
        //console.log(`MapGeoJsonService: Removing feature with ID "${featureId}"`);
        const vectorLayer = map.getLayers().getArray().find(layer => layer.get('name') === 'geomlayer');

        if (vectorLayer) {
        const vectorSource = vectorLayer.getSource();
        const feature = vectorSource.getFeatureById(featureId);

        if (feature) {
            vectorSource.removeFeature(feature);
            //console.log(`MapGeoJsonService: Feature "${featureId}" removed successfully.`);
        } else {
            console.warn(`MapGeoJsonService: Feature "${featureId}" not found in vector layer.`);
        }
        } else {
        console.warn('MapGeoJsonService: Vector layer "vector-parcelle" not found on the map.');
        }
    }

    clearVectorLayer(){
        
        let refMap = $('#map').data('map');
        let vectorSource = null;
        let mapLayers = refMap.getLayers().getArray();
        //console.log("MapGeoJsonService clearVectorLayer", mapLayers);
        mapLayers.filter(layer => layer.get('name') === 'geomlayer').forEach(layer => vectorSource = layer.getSource());
        if(vectorSource) {
            vectorSource?.getFeatures().map(feature => {
                vectorSource?.removeFeature(feature);
            })
        }
    }

    addPropParcellesLayer( refMap, geoJsonData, typeTerr=null, getExtend=true){
        let propsSource = null
        refMap = $('#map').data('map');
        let mapLayers = refMap.getLayers().getArray();
        mapLayers.filter(layer => layer.get('name') === 'proprietaire').forEach(layer =>propsSource = layer.getSource());
        (!propsSource )?propsSource = new VectorSource():null;
        geoJsonData.map((item,index)=>{
            propsSource.addFeatures(new GeoJSON().readFeatures(JSON.parse(item.geom)));
        })
        let vectorStyle = new Style({
            stroke: new Stroke({
                color: 'rgb(0,255,234)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(0,255,234,0.2)'
            })
        })
        let propsLayer = new Vector({
            source: propsSource,
            style: vectorStyle
        });
        propsLayer.set('name', 'proprietaire')
        propsLayer.set('title', 'Parcelles propriétaire')
        propsLayer.set('displayInLayerSwitcher', false)
        propsLayer.setZIndex(999);
        refMap.addLayer(propsLayer);
        refMap.getView().fit(propsSource.getExtent(),{maxZoom: 19}, refMap.getSize());
    }

    clearPropParcelleLayers(){
        let refMap = $('#map').data('map');
        let mapLayers = refMap.getLayers().getArray();
        //console.log("MapGeoJsonService clearPropParcelleLayers", mapLayers);
        mapLayers.filter(layer => layer.get('name') === 'proprietaire').forEach(layer => refMap.removeLayer(layer));
    }

    centerOnLonLat(lon, lat){
        let refMap = $('#map').data('map');
        refMap.getView().setCenter(fromLonLat([lon, lat]), 20)
    }

    centerOnParcelle(id_par){
        const refMap = $('#map').data('map');
        let mapLayers = refMap.getLayers().getArray();
        let propsSource = null;
        mapLayers.filter(layer => layer.get('name') === 'proprietaire').forEach(layer =>propsSource = layer.getSource());
        propsSource.getFeatures().forEach((feature)=> {
            if(feature.get('id_par')===id_par){
                this.centerOnFeature(feature)
                return;
            }
        })
    }

    centerOnFeature(feature){
        let propsSource = null
        let refMap = $('#map').data('map');
        propsSource = new VectorSource({features: [feature]})
        refMap.getView().fit(propsSource.getExtent(),{maxZoom: 19}, refMap.getSize());

    }

    centerOnGeom(geoJsonData){
        let propsSource = null
        let refMap = $('#map').data('map');
        propsSource = new VectorSource({features: (new GeoJSON()).readFeatures(geoJsonData)})
        refMap.getView().fit(propsSource.getExtent(),{maxZoom: 19}, refMap.getSize());
    }

    addInconstructibleLayer(geoJsonData) {
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        let vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(geoJsonData),
        });
    
        // Remove any existing "inconstructible" layers
        mapLayers
            .filter((layer) => layer.get('name') === 'inconstructible')
            .forEach((layer) => refMap.removeLayer(layer));
    
        // Define styles for the inconstructible areas
        const vectorStyle = new Style({
            stroke: new Stroke({
                color: '#FF0000', // Red color for inconstructible boundaries
                width: 2,
            }),
            fill: new Fill({
                color: 'rgba(255,0,0,0.2)', // Transparent red for inconstructible areas
            }),
        });
    
        // Create and add the layer
        const vectorLayer = new VectorLayer({
            source: vectorSource,
            style: vectorStyle,
        });
        vectorLayer.set('name', 'inconstructible'); // Set layer name for future reference
        vectorLayer.set('title', 'Inconstructible Areas');
        vectorLayer.setZIndex(999);

        refMap.addLayer(vectorLayer);
    
        // Adjust the map view to fit the new layer
        refMap.getView().fit(vectorSource.getExtent(), { maxZoom: 19 });
    }
    
    clearInconstructibleLayer() {
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        mapLayers
            .filter((layer) => layer.get('name') === 'inconstructible')
            .forEach((layer) => refMap.removeLayer(layer));
    }

    addResiduelLayer(geoJsonData) {
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        let vectorSource = new VectorSource({
            features: new GeoJSON().readFeatures(geoJsonData),
        });
        
        // Remove any existing "residuel" layers
        mapLayers
            .filter((layer) => layer.get('name') === 'residuel')
            .forEach((layer) => refMap.removeLayer(layer));
        
        // Define styles for the residuel areas
        const vectorStyle = new Style({
            stroke: new Stroke({
                color: '#fca054',
                width: 2,
            }),
            fill: new Fill({
                color: 'rgba(252, 160, 54, 0.2)',
            }),
        });
        
        // Create and add the layer
        const vectorLayer = new VectorLayer({
            source: vectorSource,
            style: vectorStyle,
        });
        vectorLayer.set('name', 'residuel');
        vectorLayer.set('title', 'Residual Areas');
        vectorLayer.setZIndex(999);
        
        refMap.addLayer(vectorLayer);
        
        // Only fit the view if the extent is not empty
        const extent = vectorSource.getExtent();
        if (!isEmptyExtent(extent)) {
            refMap.getView().fit(extent, { maxZoom: 19 });
        } else {
            console.warn("Residuel geometry extent is empty; skipping view.fit.");
        }
    }
    
    clearResiduelLayer() {
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        mapLayers
            .filter((layer) => layer.get('name') === 'residuel')
            .forEach((layer) => refMap.removeLayer(layer));
    }
    
    addZoneLayer(geoJsonData) {
        
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        let vectorSource = new VectorSource({
            
            features: new GeoJSON().readFeatures(geoJsonData),
        });
    
        let vectorStyle = new Style({
            stroke: new Stroke({
                color: 'rgb(0,255,234)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(0,255,234,0.2)'
            })
        })
    
        // Create and add the layer
        const vectorLayer = new VectorLayer({
            source: vectorSource,
            style: vectorStyle,
        });
        vectorLayer.set('name', 'zones'); // Set layer name for future reference
        vectorLayer.set('title', 'Zones Urbanisme');
        vectorLayer.setZIndex(999);
        
        refMap.addLayer(vectorLayer);
    
        // Adjust the map view to fit the new layer
        refMap.getView().fit(vectorSource.getExtent(), { maxZoom: 19 });
    }
    
    clearZoneLayer() {
        let refMap = $('#map').data('map');
        const mapLayers = refMap.getLayers().getArray();
        mapLayers
            .filter((layer) => layer.get('name') === 'zones')
            .forEach((layer) => refMap.removeLayer(layer));
    }
}



export default MapGeoJsonService
